export default {
  infoLabel: 'Component Information',
  closeLabel: 'Close Information',
  faq: {
    title: 'How does the filter work?',
    description: 'Categories are aggregated and each sub-category is divided through the spaces in each tag',
  },
  faq2: {
    title: 'What is displayed?',
    description: 'The chart only shows the selected tags, any other tag that is not selected in the filter, even if present in the filtered posts, will not appear in the chart',
  },
};
